/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Favorites/Favorites.Selectors',[
    'jquery',
    'lodash',
    'global/all',
    'plugins/jquery.proxyRequest',
    'plugins/jquery.rocparams'
], function ($, _, Roc) {
    'use strict';

    // dynamic selectors 
    function getProductPricingWrapper(index) {
        return '.itemWrapper[data-index="' + index + '"]' + ' [data-roc-binding="pricing"]';
    }

    function getSelectedUoM(index) {
        return '.itemWrapper[data-index="' +index +'"]' + ' #selectedUom';
    }

    function getSelectedQty(index) {
        return '.itemWrapper[data-index="' + index + '"]' + ' .addQty';
    }
    // end of dynamic selectors 
    var FavoritesSelectors = {
        wrappers: {
            favoriteItem: '.itemWrapper'

        },
        buttons: {
            addToCart: '[data-roc-action="addToCartFromFavorites"]'
        },
        fields: {
            uom: '.selectedUom',
            qty: '.addQty'
        },
        dynamic: {
            getProductPricingWrapper: getProductPricingWrapper,
            getSelectedUoM: getSelectedUoM,
            getSelectedQty: getSelectedQty
        }
    };

    Roc.Logger.debug('QuickOrderSelectors.js Loaded:', FavoritesSelectors);

    return FavoritesSelectors;
});
